import { useNavigate } from "react-router-dom";
const HeaderSearch = (props: any) => {
  let history = useNavigate();

  const onKeyPress = (e: any) => {
    if (e.key === "Enter" && props.contents !== "") {
      props.onSearchGoods();
    }
  };

  return (
    <div
      className="display-divide-3"
      style={{ paddingTop: "20px", paddingBottom: "20px" }}
    >
      <div className="div-goods-list-logo-img" style={{ flex: "1" }}>
        <img
          src={props.medmall_logo}
          alt="logo"
          className="goods-list-logo-img"
          onClick={() => history("/main")}
        ></img>
      </div>
      <div
        style={{ flex: "1" }}
        className="div-left-search2-form div-mobile-remove"
      >
        <div className="div-left-search2">
          <input
            placeholder="Search"
            value={props.contents}
            onChange={(e) => props.setContents(e.target.value)}
            onKeyPress={onKeyPress}
          ></input>
          <img
            src="/svg/search.svg"
            alt="search"
            onClick={() => props.onSearchGoods()}
          />
        </div>
      </div>
      <div style={{ flex: "1" }} className="div-mobile-remove"></div>
    </div>
  );
};

export default HeaderSearch;
